import { useEffect } from "react";
import { serializeJsonLd } from "../../utilities/helpers";

const JSON_LDBlok = ({ blok }) => {
  let pageStructuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": "https://www.welldoing.org/",
        url: "https://www.welldoing.org/",
        name: "Welldoing",
      },
    ],
  };

  if (blok.schema) {
    let schema;
    try {
      schema = JSON.parse(blok.schema);
    } catch (error) {
      schema = pageStructuredData;
    }
    return (
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: serializeJsonLd(schema),
        }}
      />
    );
  } else {
    return (
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: serializeJsonLd(pageStructuredData),
        }}
      />
    );
  }
};
export default JSON_LDBlok;
